import { SingleLine2 } from "./SingleLine2.js";
export class LinePointToPoint2 extends SingleLine2 {
    constructor(name, viewType, color, v1, v2, gapSize, dashSize, lineWidth) {
        super(name, viewType, color, undefined, undefined, dashSize, gapSize, lineWidth);
        this.isLinePointToPoint2 = true;
        this.updatePosition = () => {
            this._v1 && this._v2 && this.setAB(this._v1.position, this._v2.position);
        };
        this.name = name;
        this.interceptedByRaycaster = false;
        this._v1 = v1;
        this._v2 = v2;
        this.updatePosition();
        this.bindEvents();
    }
    set v1(value) {
        if (this._v1 !== value) {
            this._v1?.unbindEvent("onPositionComponentChange", this.updatePosition);
            this._v1 = value;
            this._v1?.bindEvent("onPositionComponentChange", this.updatePosition);
            this.updatePosition();
        }
    }
    get v1() {
        return this._v1;
    }
    set v2(value) {
        if (this._v2 !== value) {
            this._v2?.unbindEvent("onPositionComponentChange", this.updatePosition);
            this._v2 = value;
            this._v2?.bindEvent("onPositionComponentChange", this.updatePosition);
            this.updatePosition();
        }
    }
    get v2() {
        return this._v2;
    }
    bindEvents() {
        this._v1?.bindEvent("onPositionComponentChange", this.updatePosition);
        this._v2?.bindEvent("onPositionComponentChange", this.updatePosition);
    }
    dispose() {
        super.dispose();
        this._v1?.unbindEvent("onPositionComponentChange", this.updatePosition);
        this._v2?.unbindEvent("onPositionComponentChange", this.updatePosition);
    }
}
//# sourceMappingURL=LinePointToPoint2.js.map